/**
 * Resolves min/max price bounds for flight data filtering.
 *
 * A missing max price should behave as no upper bound, otherwise the
 * comparison `item.total <= undefined` excludes every result.
 */
export function getPriceBounds(minPrice, maxPrice) {
  return {
    min: Number.isFinite(minPrice) ? minPrice : 0,
    max: Number.isFinite(maxPrice) ? maxPrice : Infinity,
  };
}

/**
 * Validates and clamps manual price input to prevent inverted ranges.
 */
export function clampPriceInput(price, filterKey, { minPrice, maxPrice, minMaxDataRangePrice }) {
  if (filterKey === 'maxPrice') {
    return minPrice >= price ? minPrice + 1 : price;
  }

  if (filterKey === 'minPrice') {
    const currentMaxPrice = maxPrice ?? minMaxDataRangePrice[1];

    if (Number.isFinite(currentMaxPrice) && price >= currentMaxPrice) {
      return Math.max(currentMaxPrice - 1, 0);
    }

    return price;
  }

  return price;
}
